import React from 'react'
import { Redirect } from 'react-router-dom'

import LazyImport from 'src/HOC/LazyImport'
import NotFound from 'src/scenes/NotFound'

export const securedEmailRoutes = [
  {
    path: `/secured-email/:uuid`,
    component: LazyImport(() =>
      import('src/scenes/secured-emails' /* webpackChunkName: "SecuredEmail" */)
    )
  },
  {
    path: '/not-found',
    component: NotFound
  },
  {
    path: '*',
    component: () => <Redirect to="/not-found" />
  }
]
